import { Injectable } from "@angular/core";
import { Doenca } from "@tivic-team/manager-ts/dist/grl";
import { HttpFilter, HttpGet, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { Equal } from 'sol-request-angular/dist/comunicacao/filter/Equal';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';

@Injectable()
export class DoencaController {

    constructor() {}

    async find(filtros?:IFilter):Promise<Array<Doenca>>{	
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/doencas',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<Doenca>()
			)
		);
		return await quark.call();
	}

    async get(cdDoenca:number):Promise<any>{	
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/doencas/getdoenca/:cdDoenca',
					environment: environment,
					pathParams: new JSONData({cdDoenca: cdDoenca})
				}),
			}),
			new HttpResponse(
				new Object()
			)
        );
        return await quark.call();
	}

}